import { getAxiosInstance } from '../blocks/axios/axiosFactory';
import RedirectPenaltyRequest from '../models/order/RedirectPenaltyRequest';
import RedirectRequest from "../models/order/RedirectRequest";

const url = "/order";

export default class OrderService {
    static redirect(request: RedirectRequest) {
        return getAxiosInstance().get(`${url}/redirect`, { params: { ...request } });
    }

    static redirectPenalty(request: RedirectPenaltyRequest) {
        return getAxiosInstance().get(`${url}/redirectPenalty`, { params: { ... request }})
    }
}
